import { fetchWithProblem } from 'utils/Problem';
import type { IFeApiClient } from './iFeApiClient';
import type {
  CalculatePersonalLoansRequest,
  CalculatePersonalLoansResponse,
  EmailCaptureLeadRequest,
  GetApplyProductRequest,
  GetApplyProductResponse,
  GetPdpModalConfigRequest,
  GetPdpModalConfigResponse,
  GetPolicySummaryRequest,
  GetPolicySummaryResponse,
  GetCompareCandidatesRequest,
  GetCompareCandidatesResponse,
  GetProductRequest,
  GetProductResponse,
  TravelCompareQuotesRequest,
  TravelCompareQuotesResponse,
} from './types';

const API_PREFIX = '/api/-cms';

async function postJson<TResponse>(
  path: string,
  body: unknown,
): Promise<TResponse> {
  const response = await fetchWithProblem(path, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const text = await response.text();
  if (!text) return undefined as TResponse;

  return JSON.parse(text) as TResponse;
}

export const feApiFrontClient: IFeApiClient = {
  calculatePersonalLoans(
    request: CalculatePersonalLoansRequest,
  ): Promise<CalculatePersonalLoansResponse> {
    return postJson<CalculatePersonalLoansResponse>(
      `${API_PREFIX}/calculate-personal-loans`,
      request,
    );
  },

  travelCompareQuotes(
    request: TravelCompareQuotesRequest,
  ): Promise<TravelCompareQuotesResponse> {
    return postJson<TravelCompareQuotesResponse>(
      `${API_PREFIX}/travel-compare-quotes`,
      request,
    );
  },

  getCompareCandidates(
    request: GetCompareCandidatesRequest,
  ): Promise<GetCompareCandidatesResponse> {
    return postJson<GetCompareCandidatesResponse>(
      `${API_PREFIX}/compare-candidates`,
      request,
    );
  },

  getProduct(request: GetProductRequest): Promise<GetProductResponse> {
    return postJson<GetProductResponse>(`${API_PREFIX}/product`, request);
  },

  getApplyProduct(
    request: GetApplyProductRequest,
  ): Promise<GetApplyProductResponse> {
    return postJson<GetApplyProductResponse>(
      `${API_PREFIX}/apply-product`,
      request,
    );
  },

  submitEmailCaptureLead(request: EmailCaptureLeadRequest): Promise<void> {
    return postJson<void>(`${API_PREFIX}/email-capture-lead`, request);
  },

  getPolicySummary(
    request: GetPolicySummaryRequest,
  ): Promise<GetPolicySummaryResponse> {
    return postJson<GetPolicySummaryResponse>(
      `${API_PREFIX}/policy-summary`,
      request,
    );
  },

  getPdpModalConfig(
    request: GetPdpModalConfigRequest,
  ): Promise<GetPdpModalConfigResponse> {
    return postJson<GetPdpModalConfigResponse>(
      `${API_PREFIX}/pdp-modal-config`,
      request,
    );
  },
};
